import { jsxs as _jsxs } from "react/jsx-runtime";
export const StepLink = props => {
  function handleClick(event) {
    if (props.onClick) {
      event.preventDefault();
      props.onClick(props.href, props.stepId);
    }
  }
  const ComponentType = props.component ?? 'a';
  return /*#__PURE__*/_jsxs(ComponentType, {
    href: props.href,
    onClick: handleClick,
    className: props.className,
    children: [props.children, props.screenReaderText && /*#__PURE__*/_jsxs("span", {
      className: "ds-u-visibility--screen-reader",
      children: [" ", props.screenReaderText]
    })]
  });
};
export default StepLink;